module.exports = __webpack_public_path__ + "img/bezlimit2.cc880bfe.png";